<p-table
  [value]="page.items"
  [first]="filterVal.first"
  [lazy]="true"
  [rows]="10"
  [responsive]="true"
  [paginator]="isViewModeDynamic"
  [rowHover]="isViewModeDynamic"
  [sortField]="filterVal.sortField"
  [sortOrder]="filterVal.sortOrder"
  resizableColumns="true"
  [totalRecords]="page.total"
  (onLazyLoad)="onGridLazyLoad($event)"
  [hidden]="!isLoaded"
  selectionMode="single"
  [rowsPerPageOptions]="[5, 10, 20]"
  [pageLinks]="3"
>
  <ng-template pTemplate="header">
    <tr>
      <th *ngIf="isSupplierMode || isCustomerMode">Transaction Number</th>
      <th>Account Code</th>
      <th>Description</th>
      <th>Amount</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr [pSelectableRow]="item">
      <td>
        <span *ngIf="isSupplierMode">
          <span *ngIf="!item.transactionNumber">
            <a
              *ngIf="isViewModeDynamic"
              href="#"
              (click)="supplierJobScreen(item); $event.preventDefault()"
              >{{ item.jobNumber }}</a
            >
            <span *ngIf="!isViewModeDynamic">{{ item.jobNumber }}</span>
          </span>
          <span *ngIf="item.transactionNumber">
            {{ item.transactionNumber }}
          </span>
        </span>
        <span *ngIf="isCustomerMode">
          <span *ngIf="!item.transactionNumber">
            <a href="#" (click)="customerJobScreen(item); $event.preventDefault()">{{
              item.orderNumber
            }}</a>
          </span>
          <span *ngIf="item.transactionNumber">
            {{ item.transactionNumber }}
          </span>
        </span>
      </td>
      <td>
        {{ item.accountCode }}
      </td>
      <td>
        {{ item.description }}
      </td>
      <td>
        {{ item.amount | currency : 'GBP' : 'symbol' : '1.2-2' }}
      </td>
    </tr>
  </ng-template>
</p-table>

<!--
<p-dataTabl [value]="page.items" [first]="filterVal.first" [lazy]="true" [rows]="10" [responsive]="true" [paginator]="isViewModeDynamic"
             [rowHover]="isViewModeDynamic" [sortField]="filterVal.sortField" [sortOrder]="filterVal.sortOrder"
             resizableColumns="true" [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)" 
             [hidden]="!isLoaded" selectionMode="single" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3">
    <p-column *ngIf="isSupplierMode" field="jobNumber" header="Transaction Number" [sortable]="isViewModeDynamic" [style]="{'width' : '20%'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
            <ng-container *ngIf="!item['transactionNumber']">
                <a *ngIf="isViewModeDynamic" href='#' (click)="supplierJobScreen(item);$event.preventDefault();">{{item[col.field]}}</a>
                <span *ngIf="!isViewModeDynamic">{{item[col.field]}}</span>
            </ng-container>
            <ng-container *ngIf="item['transactionNumber']">
                <span>{{item['transactionNumber']}}</span>
            </ng-container>
        </ng-template>
    </p-column>
    <p-column *ngIf="isCustomerMode" field="orderNumber" header="Transaction Number" [sortable]="isViewModeDynamic" [style]="{'width' : '20%'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
            <ng-container *ngIf="!item['transactionNumber']">
                <a href='#' (click)="customerJobScreen(item);$event.preventDefault();">{{item[col.field]}}</a>
            </ng-container>
            <ng-container *ngIf="item['transactionNumber']">
                <span>{{item['transactionNumber']}}</span>
            </ng-container>
        </ng-template>
    </p-column>

    <p-column field="accountCode" header="Account Code" [sortable]="isViewModeDynamic"
              [style]="{'width' : '20%'}" styleClass="align-center"></p-column>
    <p-column field="description" header="Description" [sortable]="isViewModeDynamic"></p-column>
    <p-column field="amount" header="Amount" [sortable]="isViewModeDynamic" [style]="{'width' : '15%'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
            {{ item[col.field] | currency:'GBP':'symbol':'1.2-2' }}
        </ng-template>
    </p-column>
</p-dataTable>

--->
